import React, { useEffect, useState } from 'react'
import { makeGetCall, makeNextPageCall } from '../../../effects/requests';
import { endPoints } from '../../../utils/endpoints';
import { ApiResponseType } from '../../../types';
import InfiniteScroll from 'react-infinite-scroll-component';

const CollectionImages = ({ collectionDetails, onClick }: any) => {

    const [allLocationCol, setAllLocationCol] = useState<any>([])
    const [next, setNext] = useState<any>(null)

    const fetchCollectionLoc = () => {
        makeGetCall(endPoints.ASIGN_LOCATION_TO_COLLECTION, { collection_id: collectionDetails?.id }).then((res: ApiResponseType<any>) => {
            if (res?.status?.code == 200) {
                const data = res?.results?.length > 0 ? res?.results : [];
                setAllLocationCol(data);
                setNext(res?.next);
            }
        })
    }

    const fetchMoreData = () => {
        if (!next) return;

        makeNextPageCall(next, false, true).then(
            (res: ApiResponseType<any>) => {
                setAllLocationCol([...allLocationCol, ...res.results]);
                setNext(res?.next);
            }
        );
    };

    useEffect(() => {
        if (collectionDetails?.id)
            fetchCollectionLoc();
    }, [collectionDetails?.id])

    return (
        <InfiniteScroll
            dataLength={allLocationCol}
            next={fetchMoreData}
            hasMore={next ? true : false}
            loader={null}
            scrollableTarget="scrollableId"
        >
            <div className={`lv-grid`}>
                {allLocationCol?.map((loc: any, index: any) => {
                    return (
                        <div
                            key={loc?.id}
                            onClick={() => onClick(loc)}
                            className='lv-card'
                        >
                            <img
                                src={loc?.thumbnail || '/assets/images/yellow-6th.png'}
                                alt={loc.name}
                                className="lv-card__img"
                            />
                            <div className="lv-card__overlay">
                                <div className="lv-card__info">
                                    <span className="lv-card__name">{loc?.name}</span>
                                    <span className="lv-card__city">{loc?.address}</span>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </InfiniteScroll>
    )
}

export default CollectionImages